import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import Swal from 'sweetalert2';
import axios from '../../../utils/axiosConfig';
import 'boxicons/css/boxicons.min.css';
import FormModalCreateUsuarioStreaming from '../forms/formModalCreateUsuarioStreaming';

const ModalUsuariosStreaming = () => {
    const [view, setView]                 = useState('list'); // 'list' | 'form'
    const [usuarios, setUsuarios]         = useState([]);
    const [listProyectos, setListProyectos] = useState([]);
    const [listEmpresas, setListEmpresas]   = useState([]);
    const [listRoles, setListRoles]         = useState([]);
    const [searchTerm, setSearchTerm]     = useState('');
    const [debouncedTerm, setDebouncedTerm] = useState('');
    const [selectedUsuario, setSelectedUsuario] = useState(null);
    const [loading, setLoading]           = useState(false);

    // â”€â”€â”€ helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const normalizarListaUsuarios = (data) => {
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.recordset)) return data.recordset;
        if (Array.isArray(data?.rows)) return data.rows;
        if (Array.isArray(data?.roles)) return data.roles;
        return [];
    };

    const normalizarRoles = (data) => normalizarListaUsuarios(data)
        .map((role) => {
            const id = getField(role, ['role_id', 'RoleId', 'IDRol', 'id', 'ID'], '');
            const name = getField(
                role,
                ['role_name', 'RoleName', 'NombreRol', 'name', 'descripcion', 'Descripcion', 'label', 'role'],
                id
            );
            return id === '' ? null : { id: String(id), name: String(name) };
        })
        .filter(Boolean);

    const getField = (item, candidates, fallback = '-') => {
        for (const key of candidates) {
            const value = item?.[key];
            if (value !== undefined && value !== null && String(value).trim() !== '') {
                return value;
            }
        }
        return fallback;
    };

    const getNormalizedProjectId   = (item) => getField(item, ['IdProyecto', 'IDProyecto', 'id', 'project', 'Proyecto']);
    const getNormalizedProjectName = (item) => getField(item, ['NombreProyecto', 'Proyecto', 'project_name', 'descripcion', 'Descripcion']);
    const getNormalizedCompanyId   = (item) => getField(item, ['IdEmpresa', 'IDEmpresa', 'id', 'company', 'empresa']);
    const getNormalizedCompanyName = (item) => getField(item, ['NombreEmpresa', 'Empresa', 'empresa', 'descripcion', 'Descripcion']);
    const getNormalizedRoleId = (item) => getField(item, ['role_id', 'RoleId', 'IDRol', 'user_type'], '');

    // â”€â”€â”€ API: listar usuarios â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const listarUsuariosStreaming = useCallback(() => {
        setLoading(true);
        axios
            .get(process.env.REACT_APP_SERVER + '/operaciones2/obtenerusuariosapp', {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res?.data?.success === false) {
                    Swal.fire('Error', res?.data?.message || 'No se pudo cargar el listado de usuarios.', 'error');
                    return;
                }
                setUsuarios(normalizarListaUsuarios(res?.data?.data));
            })
            .catch(() => {
                Swal.fire('Error', 'Falla de red al cargar usuarios de streaming.', 'error');
            })
            .finally(() => setLoading(false));
    }, []);

    // â”€â”€â”€ API: catÃ¡logos (proyectos + empresas) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        const loadCatalogs = async () => {
            try {
                const proyectosRes = await axios.get(
                    process.env.REACT_APP_SERVER + '/usuarios/getlistaproyectos',
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                        },
                        withCredentials: true,
                    }
                );

                if (!proyectosRes.data.success) { window.location = '/'; return; }

                const proyectos = normalizarListaUsuarios(proyectosRes.data.data);
                setListProyectos(proyectos);

                try {
                    const rolesRes = await axios.get(
                        process.env.REACT_APP_SERVER + '/operaciones2/obtenerrolesapp',
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                            },
                            withCredentials: true,
                        }
                    );
                    setListRoles(normalizarRoles(rolesRes?.data?.data ?? rolesRes?.data));
                } catch (rolesError) {
                    console.error('Error cargando roles de usuarios streaming:', rolesError);
                    setListRoles([]);
                }

                const empresasPorProyecto = await Promise.all(
                    proyectos.map(async (proyecto) => {
                        const proyectoId = getNormalizedProjectId(proyecto);
                        try {
                            const res = await axios.post(
                                process.env.REACT_APP_SERVER + '/usuarios/getlistaempresa',
                                JSON.stringify({ proyecto: proyectoId }),
                                {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                                    },
                                    withCredentials: true,
                                }
                            );
                            const lista = Array.isArray(res.data.data) ? res.data.data : [];
                            return lista.map((e) => ({ ...e, __proyectoId: proyectoId }));
                        } catch {
                            return [];
                        }
                    })
                );

                setListEmpresas(empresasPorProyecto.flat());
            } catch (error) {
                console.error(error);
            }
        };

        loadCatalogs();
        listarUsuariosStreaming();
    }, [listarUsuariosStreaming]);

    // â”€â”€â”€ resolvers para mostrar nombres en la tabla â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const resolveProjectName = (projectId) => {
        const value = String(projectId ?? '').trim();
        if (!value) return '-';
        const proyecto = listProyectos.find(
            (item) => String(getNormalizedProjectId(item) ?? '').trim() === value
        );
        return proyecto ? getNormalizedProjectName(proyecto) : value;
    };

    const resolveCompanyName = (projectId, companyId) => {
        const projectValue = String(projectId ?? '').trim();
        const companyValue = String(companyId ?? '').trim();
        if (!companyValue) return '-';
        const empresa = listEmpresas.find((item) => {
            const currentCompanyId  = String(getNormalizedCompanyId(item) ?? '').trim();
            const currentProjectId  = String(item?.__proyectoId ?? getNormalizedProjectId(item) ?? '').trim();
            const matchesProject    = !projectValue || currentProjectId === projectValue;
            return currentCompanyId === companyValue && matchesProject;
        });
        return empresa ? getNormalizedCompanyName(empresa) : companyValue;
    };

    const resolveRoleName = (item) => {
        const roleId = String(getNormalizedRoleId(item) ?? '').trim();
        if (!roleId) return '-';
        const role = listRoles.find((current) => current.id === roleId);
        return role?.name || getField(item, ['role_name', 'RoleName', 'NombreRol', 'user_type'], roleId);
    };

    // â”€â”€â”€ debounce â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    const filtered = useMemo(() => {
        if (!debouncedTerm) return usuarios;
        return usuarios.filter((item) => {
            const resolvedProjectName = resolveProjectName(item?.project);
            const resolvedCompanyName = resolveCompanyName(item?.project, item?.company);
            const resolvedRoleName = resolveRoleName(item);

            const searchableValues = [
                ...Object.values(item || {}),
                resolvedProjectName,
                resolvedCompanyName,
                resolvedRoleName,
            ];

            return searchableValues.some((value) =>
                String(value || '').toLowerCase().includes(debouncedTerm)
            );
        });
    }, [usuarios, debouncedTerm, listProyectos, listEmpresas, listRoles]);

    // â”€â”€â”€ navegaciÃ³n lista / formulario â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const openCreate = useCallback(() => {
        setSelectedUsuario(null);
        setView('form');
    }, []);

    const openEdit = useCallback((item) => {
        setSelectedUsuario(item);
        setView('form');
    }, []);

    const closeForm = useCallback(() => {
        setSelectedUsuario(null);
        setView('list');
        listarUsuariosStreaming();
    }, [listarUsuariosStreaming]);

    // â”€â”€â”€ render â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    if (view === 'form') {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">
                            {selectedUsuario ? 'Editar Usuario Streaming' : 'Crear Usuario Streaming'}
                        </h5>
                        <button
                            type="button"
                            className="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                            onClick={closeForm}
                        >
                            <i className="bx bx-arrow-back" aria-hidden="true" />
                            Volver
                        </button>
                    </div>

                    <FormModalCreateUsuarioStreaming
                        onClose={closeForm}
                        selectedUsuario={selectedUsuario}
                        listProyectos={listProyectos}
                        listEmpresas={listEmpresas}
                    />
                </div>
            </div>
        );
    }

    return (
        <>
            <Row className="mb-4 align-items-center">
                <Col sm="8">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar usuario de streaming..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="4"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue"
                        onClick={openCreate}
                        style={{ height: '38px', minWidth: '160px', display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                        <i className="bx bx-user-plus" style={{ fontSize: '18px' }} />
                        Crear Usuario
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto', tableLayout: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th style={{ color: '#ffffff', width: '18%', textAlign: 'center' }}>Usuario</th>
                                <th style={{ color: '#ffffff', width: '12%', textAlign: 'center' }}>Estado</th>
                                <th style={{ color: '#ffffff', width: '12%', textAlign: 'center' }}>Balance</th>
                                <th style={{ color: '#ffffff', width: '20%', textAlign: 'center' }}>Empresa</th>
                                <th style={{ color: '#ffffff', width: '20%', textAlign: 'center' }}>Proyecto</th>
                                <th style={{ color: '#ffffff', width: '10%', textAlign: 'center' }}>Tipo</th>
                                <th style={{ color: '#ffffff', width: '8%',  textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan={7} className="text-center py-4">
                                        Cargando usuarios...
                                    </td>
                                </tr>
                            ) : filtered.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="text-center py-4">
                                        No se encontraron usuarios.
                                    </td>
                                </tr>
                            ) : (
                                filtered.map((item, index) => (
                                    <tr key={getField(item, ['id', 'IdUsuario', 'ID'], index)}>
                                        <td style={{ color: '#000', textAlign: 'center' }}>
                                            {getField(item, ['username', 'userName', 'Usuario', 'UserName'])}
                                        </td>
                                        <td style={{ color: '#000', textAlign: 'center' }}>
                                            <span className={`badge ${item?.is_active === true ? 'bg-success' : 'bg-danger'}`}>
                                                {item?.is_active === true ? 'Activo' : 'Inactivo'}
                                            </span>
                                        </td>
                                        <td style={{ color: '#000', textAlign: 'center' }}>
                                            {getField(item, ['balance'], 0)}
                                        </td>
                                        <td style={{ color: '#000', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                            {resolveCompanyName(item?.project, item?.company)}
                                        </td>
                                        <td style={{ color: '#000', textAlign: 'center', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                            {resolveProjectName(item?.project)}
                                        </td>
                                        <td style={{ color: '#000', textAlign: 'center', textTransform: 'capitalize', whiteSpace: 'normal' }}>
                                            {resolveRoleName(item)}
                                        </td>
                                        <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                            <button
                                                title="Editar"
                                                onClick={() => openEdit(item)}
                                                style={{
                                                    background: 'none', border: 'none',
                                                    cursor: 'pointer', color: '#006699',
                                                    fontSize: '20px', padding: '2px 6px', lineHeight: 1,
                                                }}
                                            >
                                                <i className="bx bx-edit" />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default ModalUsuariosStreaming;
